<section class="page-hero page-hero-about" aria-labelledby="about-page-title">
  <div>
    <h1 id="about-page-title">About us</h1>
  </div>
  <p>
    Pavillion Properties develops considered Nairobi residences for homeowners, investors, and the
    communities around them.
  </p>
</section>

<section class="section about-story" aria-label="Pavillion Properties mission and vision">
  <div class="about-principles" aria-label="Pavillion Properties mission and vision">
    <article>
      <span>Mission</span>
      <h3>Build homes that make Nairobi ownership clearer.</h3>
      <p>
        To deliver design-led residences with transparent buying guidance, practical layouts, and
        dependable support from first viewing to key handover.
      </p>
    </article>
    <article>
      <span>Vision</span>
      <h3>Shape better urban living for the next generation of buyers.</h3>
      <p>
        To be a trusted Nairobi developer known for thoughtful architecture, credible delivery, and
        homes that hold long-term value for residents and investors.
      </p>
    </article>
  </div>
</section>

<section class="section about-team-section" aria-labelledby="team-title">
  <div class="section-heading-row about-team-heading">
    <h2 id="team-title">Team members</h2>
    <p>
      The Pavillion team works across development, client advisory, design coordination, and project
      delivery so each buyer has a clear path from inquiry to ownership.
    </p>
  </div>

  <div class="team-list" aria-label="Pavillion Properties team members">
    @for (member of teamMembers; track member.name) {
      <article class="team-member">
        <span class="team-avatar" aria-hidden="true">
          <svg class="material-icon" focusable="false" viewBox="0 0 24 24">
            <path
              d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm0 2c-3.31 0-6 1.79-6 4v1h12v-1c0-2.21-2.69-4-6-4Z"
            />
          </svg>
        </span>
        <div>
          <span class="team-member-meta">{{ member.department }}</span>
          <h3>{{ member.name }}</h3>
          <p>{{ member.title }}</p>
        </div>
      </article>
    }
  </div>
</section>

<section class="section purchase-strip" aria-labelledby="about-cta-title">
  <div>
    <h2 id="about-cta-title">Want to speak with the Pavillion team?</h2>
  </div>
  <button class="primary-button dark-button" type="button" (click)="inquiryRequested.emit()">
    Inquire now
    <svg class="material-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24">
      <path d="M12 4 10.59 5.41 15.17 10H4v2h11.17l-4.58 4.59L12 20l8-8z" />
    </svg>
  </button>
</section>
